import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Box } from '../box/box';
import { useTheme } from '../styles/styles';
import { NavigationMenu } from './navigation-menu';
import { SettingsRouteConfiguration } from './settings-route-configuration';
import { SidebarTabsLayoutProps } from './types';

export const SidebarTabsLayoutComponent = ({
  routesConfigItems,
  onChangeSubMenu,
}: SidebarTabsLayoutProps) => {
  const location = useLocation();

  useEffect(() => {
    if (!routesConfigItems?.length || !onChangeSubMenu) return;

    const tabPaths = routesConfigItems
      .map((item) => item.path)
      .filter((p): p is string => Boolean(p));

    const hasTabInPath = tabPaths.some((tabPath) =>
      location.pathname.includes(`/${tabPath}`)
    );

    if (!hasTabInPath) {
      const firstWithPath = routesConfigItems.find((item) => item.path);
      if (firstWithPath) {
        onChangeSubMenu(firstWithPath.path);
      }
    }
  }, [location.pathname, routesConfigItems, onChangeSubMenu]);
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
      }}
      width={'100%'}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          width: '100%',
          borderRadius: '10px',
          border: `1px solid ${theme.background.lightGrey3}`,
          backgroundColor: theme.background.lightGrey4,
          height: '56px',
          justifyContent: 'center',
          padding: '0 9px',
          marginTop: '12px',
          marginBottom: '20px',
        }}
      >
        <NavigationMenu
          items={routesConfigItems}
          onChangeSubMenu={(route) => onChangeSubMenu(route)}
        />
      </Box>
      <Box
        className="profile"
        sx={{
          flex: 1,
          display: 'flex',
          minHeight: 0,
          minWidth: 0,
          overflow: 'hidden',
        }}
      >
        <SettingsRouteConfiguration items={routesConfigItems} />
      </Box>
    </Box>
  );
};
